import {inject, Injectable} from "@angular/core";
import {MessageService} from "primeng/api";
import {AlertInstance} from "../interfaces/domain/alert/AlertInstance";

@Injectable()
export class ToastAlertService {

  private readonly key = 'alert';

  private readonly messageService = inject(MessageService);

  constructor() {
    // empty
  }

  showAlertInstance(alertInstance: AlertInstance): void {
    this.messageService.add({
      key: this.key,
      data: alertInstance,
      life: 10000,
    });
  }
}
